<template>
  <UContainer class="mx-auto grow py-8 px-2 lg:py-12 max-w-[1200px]">
    <slot />
  </UContainer>
</template>
